export type SidebarItemId =
  | 'dashboard'
  | 'apis'
  | 'architecture.products'
  | 'docs';

type GroupKey = 'internal' | 'external';

export const SIDEBAR_ACCESS_BY_GROUP: Record<GroupKey, ReadonlyArray<SidebarItemId>> = {
  internal: [
    'dashboard',
    'apis',
    'docs',
    'architecture.products'
  ],
  external: [
    'dashboard', 
    'apis']
};

export const DEFAULT_ACCESS: ReadonlyArray<SidebarItemId> = ['dashboard'];


